import { render, staticRenderFns } from "./AttendantEvaluation.vue?vue&type=template&id=f52a52ec&scoped=true"
import script from "./AttendantEvaluation.vue?vue&type=script&lang=js"
export * from "./AttendantEvaluation.vue?vue&type=script&lang=js"
import style0 from "./AttendantEvaluation.vue?vue&type=style&index=0&id=f52a52ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52a52ec",
  null
  
)

export default component.exports